import { IStorageQuotaData, IStorageQuotaDataBase } from './types';

export const enrichStorageQuotaData = (
  storageQuotaDataBase: IStorageQuotaDataBase,
  isStorageQuotaEnforcementEnabled: boolean,
): IStorageQuotaData => {
  if (!storageQuotaDataBase) {
    return undefined;
  }

  const {
    quota: {
      storage: quota,
      plans: { upgradeUrl },
    },
    usage: { storage: usage },
  } = storageQuotaDataBase;
  const isOverquota = quota !== -1 && usage > quota;
  return {
    ...storageQuotaDataBase,
    status: (() => {
      const usagePercentage = (usage / quota) * 100;

      if (quota === -1) {
        return 'storageQuotaStatusUnlimited';
      } else if (usagePercentage >= 100) {
        return 'storageQuotaStatusFull';
      } else if (usagePercentage >= 95 && usagePercentage < 100) {
        return 'storageQuotaStatusWarning';
      } else {
        return 'storageQuotaStatusStandard';
      }
    })(),
    isOverquota,
    uploadsRestricted: isStorageQuotaEnforcementEnabled && isOverquota,
    upgradeUrl,
  };
};
